module.exports = __webpack_public_path__ + "static/img/11.5147360.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/7/1/zh/11.png
// module id = NRK+
// module chunks = 0